module.exports = __webpack_public_path__ + "static/media/b2.45e6017e.jpg";